export const CLOCKODO_API_BASE_URL = "https://my.clockodo.com/api";
